
import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, Type, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationExtras, NavigationStart, Router } from '@angular/router';

import { alert, confirm, custom } from 'devextreme/ui/dialog';
import { messagefromComponent } from '../../class/appinterface';
import { NicaInfoAnagraficaAziendaComponent } from '../../components/anagrafiche/nica-info-anagrafica-azienda/nica-info-anagrafica-azienda.component';
import { NicaDynamicContentComponent } from '../../components/nica-dynamic-content/nica-dynamic-content.component';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { NicaMapsComponent } from '../../widgets/nica-maps/nica-maps.component';
import notify from 'devextreme/ui/notify';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { NicaFiltroComponent } from '../../components/shared/nica-filtro/nica-filtro.component';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';
import { Utenteservice } from '../../services/utente.service';



@Component({
  selector: 'app-anaa-soggetto',
  templateUrl: './ana-soggetto.component.html',
  styleUrls: ['./ana-soggetto.component.css'],

})
export class AnaSoggettoComponent extends NicaMaster implements OnInit, AfterViewInit {
  //@ViewChild('formSoggetto', { static: false }) formSoggetto: NicaFormComponent;
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent;
  @ViewChild('dynamicComponent', { static: false }) dynamicComponent: NicaDynamicContentComponent;
  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent;

  //Props per Filtri Avanzati
  pannelloFiltriAvanzatiVisibile: boolean = false;
  filterTemplateKey?: string = 'soggettiFiltri';

  @ViewChild('nicaFiltroSoggetti', { static: false }) nicaFiltroSoggetti: NicaFiltroComponent;


  @Input() itemData: any
  @Input() InviaA: any
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();

  soggettoTabs: any[];
  dataToSend: any[];
  filterUL: string = '';
  templateTab: any = {
    soggetto: 'grid',
    Configurazioni: 'component',
    ConfigurazioniModuloViviFir: 'component',

  }
  selectedIndex: any =
    {
      soggetto: 0,
      Configurazioni: 1,
      ConfigurazioniModuloViviFir: 2,

    }
  datiVivirir: {};
  formisRemoteOperation: boolean = true
  idTipoUtente: number = 3;
  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    private utenteService: Utenteservice,
    private changeDetector?: ChangeDetectorRef,
    private http?: HttpClient

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,



    );


  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('AnaSoggetto On Changed', changes)
  }

  ngOnInit(): void {


    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.setTabsSoggetto(this.itemData[0]);

    } else {
      this.showToolBar = false
      this.activatedroute.queryParams.subscribe((params) => {

        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName

        this.idTipoUtente = this.utenteService.InfoUtenteConnesso.idtipoutente
        console.log(params, 'parametri')
        this.setGlobalVariableFromParams(params)
        this.setTabsSoggetto(params);


        if (this.template == 'grid' && this.SubjectCall == 'soggetto') {

          this.userComponentService.removeAllItemComponentFromID('sede', this.currentTabId)
        }



        if (this.filterID['NostreAziende'] == 'N') {
          this.helpDoc = 'AnagraficaOperatori.html'
        } else {
          this.helpDoc = 'Anagrafichepropriimpianti.html'
        }

        console.log('helpDoc', this.helpDoc);
      });


    }


    //Pulisce il breadcrumbNavigation se già settato ogni qualc     
    if (this.breadcrumbNavigation.length >= 2) {
      const id = this.SubjectCall;
      this.userComponentService.removeLastItemComponentNavigation(this.currentTabId);
    }

    /* //Pulisce il breadcrumbNavigation se già settato ogni qualc     
    if (this.SubjectCall == 'ConfigurazioniModuloRentri') {
      this.filterID['isEdit'] = false
      this.formisRemoteOperation = false
    } */


  }

  onAllEventFiltro(ev) {

    if (ev !== 'salva')
      try {

        if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['uL_IdRegione'] && ev.campo.dataField == 'uL_IdRegione') {
          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_SiglaProvincia', undefined);
          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_Comune', undefined);

        }
        if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['uL_Comune'] && ev.campo.dataField == 'uL_Comune') {

          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_SiglaProvincia', undefined);
          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_IdRegione', undefined);
        }
        else if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['uL_SiglaProvincia'] && ev.campo.dataField == 'uL_SiglaProvincia') {

          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_Comune', undefined);
          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_IdRegione', undefined);

        }


        if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['sD_Comune'] && ev.campo.dataField == 'sD_Comune')
          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('sD_SiglaProvincia', undefined);
        else if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['sD_SiglaProvincia'] && ev.campo.dataField == 'sD_SiglaProvincia')
          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('sD_Comune', undefined);
      } catch (ex) {

        console.error('ERRORE', ex);
        //console.warn(ev);
        //console.warn(this.nicaFiltroSoggetti.filtroForm.formEdit.formData);

        if (ev.formDataChanged) {
          if (ev.formDataChanged['uL_IdRegione'])
            this.nicaFiltroSoggetti.filtroForm.formEdit.formData['uL_IdRegione'] = ev.formDataChanged['uL_IdRegione'];

          if (ev.formDataChanged['sD_Comune'])
            this.nicaFiltroSoggetti.filtroForm.formEdit.formData['sD_Comune'] = ev.formDataChanged['sD_Comune'];

          if (ev.formDataChanged['uL_Comune'])
            this.nicaFiltroSoggetti.filtroForm.formEdit.formData['uL_Comune'] = ev.formDataChanged['uL_Comune'];


        }
        //this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('sD_Comune',ev.formDataChanged['sD_Comune']);

      }

    /*
    if(ev!=='salva' && (this.nomeTemplate == 'unitaLocaliFiltri' || this.nomeTemplate == 'soggettiFiltri'))
    try{
    if(this.nicaFiltroSoggetti.filtroForm.formEdit.formData['uL_IdRegione'] && ev.campo.dataField=='uL_IdRegione'){
  
      this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_SiglaProvincia',undefined);
      this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_Comune',undefined);
  
  
    }
    
      
    
  
  }catch(ex){
  
    //console.error('ERRORE',ex);
    //console.warn(ev);
    //console.warn(this.nicaFiltroSoggetti.filtroForm.formEdit.formData);
  
    if(ev.formDataChanged){
  
      if(ev.formDataChanged['sD_Comune'])
        this.nicaFiltroSoggetti.filtroForm.formEdit.formData['sD_Comune'] = ev.formDataChanged['sD_Comune'];
  
        if(ev.formDataChanged['uL_Comune'])
        this.nicaFiltroSoggetti.filtroForm.formEdit.formData['uL_Comune'] = ev.formDataChanged['uL_Comune'];
  
  
    }
        //this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('sD_Comune',ev.formDataChanged['sD_Comune']);
  
  }
  */

    try {

      if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['soloUnitaLocaliEstereCheckBox'] !== undefined && ev.component) {

        //console.warn('spipposs',ev);

        if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['soloUnitaLocaliEstereCheckBox'] == true && ev.component) {

          ev.component.itemOption('uL_Stato', 'disabled', false);
          ev.component.getEditor('uL_Stato').option('disabled', false);


        }


        if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['soloUnitaLocaliEstereCheckBox'] == false && ev.component) {

          ev.component.itemOption('uL_Stato', 'disabled', true);
          ev.component.getEditor('uL_Stato').option('disabled', true);


          this.nicaFiltroSoggetti.filtroForm.formEdit.formData['uL_Stato'] = undefined;

        }



      }


      if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['soloSoggettiEsteriCheckBox'] !== undefined && ev.component) {

        //console.warn('spipposs',ev);

        if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['soloSoggettiEsteriCheckBox'] == true && ev.component) {

          ev.component.itemOption('sD_Stato', 'disabled', false);
          ev.component.getEditor('sD_Stato').option('disabled', false);


        }


        if (this.nicaFiltroSoggetti.filtroForm.formEdit.formData['soloSoggettiEsteriCheckBox'] == false && ev.component) {

          ev.component.itemOption('sD_Stato', 'disabled', true);
          ev.component.getEditor('sD_Stato').option('disabled', true);


          this.nicaFiltroSoggetti.filtroForm.formEdit.formData['sD_Stato'] = undefined;


        }



      }

      //console.warn(ev);
    } catch (ex) {

      console.warn(ex);

    }

    if (ev.name == 'ValueChangedLista') {

      if (ev.campo.dataField == 'uL_Stato') {

        if (!ev.value) {

          ev.component.itemOption('datiPrincipaliSede.uL_SiglaProvincia', 'disabled', false);
          ev.component.getEditor('uL_SiglaProvincia').option('disabled', false);



          ev.component.itemOption('datiPrincipaliSede.sD_Comune', 'disabled', false);
          ev.component.getEditor('uL_Comune').option('disabled', false);



        }
        else if (ev.value.toLowerCase() == 'it') {

          ev.component.itemOption('datiPrincipaliSede.uL_SiglaProvincia', 'disabled', false);
          ev.component.getEditor('uL_SiglaProvincia').option('disabled', false);



          ev.component.itemOption('datiPrincipaliSede.sD_Comune', 'disabled', false);
          ev.component.getEditor('uL_Comune').option('disabled', false);



        }
        else if (ev.value.toLowerCase() !== 'it') {

          ev.component.itemOption('datiPrincipaliSede.uL_SiglaProvincia', 'disabled', true);
          ev.component.getEditor('uL_SiglaProvincia').option('disabled', true);

          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_SiglaProvincia', undefined);

          ev.component.itemOption('datiPrincipaliSede.sD_Comune', 'disabled', true);
          ev.component.getEditor('uL_Comune').option('disabled', true);


          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('uL_Comune', undefined);


        }


      }

      if (ev.campo.dataField == 'sD_Stato') {


        if (!ev.value) {

          ev.component.itemOption('datiPrincipaliSoggetto.sD_SiglaProvincia', 'disabled', false);
          ev.component.getEditor('sD_SiglaProvincia').option('disabled', false);

          ev.component.itemOption('datiPrincipaliSoggetto.sD_Comune', 'disabled', false);
          ev.component.getEditor('sD_Comune').option('disabled', false);



        }
        else if (ev.value.toLowerCase() == 'it') {

          ev.component.itemOption('datiPrincipaliSoggetto.sD_SiglaProvincia', 'disabled', false);
          ev.component.getEditor('sD_SiglaProvincia').option('disabled', false);

          ev.component.itemOption('datiPrincipaliSoggetto.sD_Comune', 'disabled', false);
          ev.component.getEditor('sD_Comune').option('disabled', false);



        }
        else if (ev.value.toLowerCase() !== 'it') {

          ev.component.itemOption('datiPrincipaliSoggetto.sD_SiglaProvincia', 'disabled', true);
          ev.component.getEditor('sD_SiglaProvincia').option('disabled', true);

          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('sD_SiglaProvincia', undefined);


          ev.component.itemOption('datiPrincipaliSoggetto.sD_Comune', 'disabled', true);
          ev.component.getEditor('sD_Comune').option('disabled', true);

          this.nicaFiltroSoggetti.filtroForm.formEdit.instance.updateData('sD_Comune', undefined);

        }


      }


      /*
      // SOGGETTO SIGLA PROVINCIA
      if(ev.campo.dataField == 'sD_SiglaProvincia'){
  
        ev.component.itemOption('datiPrincipaliSoggetto.sD_Comune', 'value', undefined);
        ev.component.getEditor('sD_Comune').option('value', undefined);
  
  
        this.filtroForm.formEdit.instance.updateData('sD_Comune',undefined);
      
        
      }
  
      
      // SEDE SIGLA PROVINCIA
      if(ev.campo.dataField == 'uL_SiglaProvincia'){
  
        ev.component.itemOption('datiPrincipaliSede.uL_Comune', 'value', undefined);
        ev.component.getEditor('uL_Comune').option('value', undefined);
  
  
        this.filtroForm.formEdit.instance.updateData('uL_Comune',undefined);
  
      }
      */
    }


  }


  ngAfterViewInit(): void {

    /* setTimeout(() => {

      let element: JQuery<HTMLElement> = $('.passwordfied input');

      if (element) {

        element.css('-webkit-text-security', 'disc');

      }

    }, 700); 

    this.changeDetector.detectChanges();*/
  }


  onBreadCrumbClicked(evt) {

    console.warn(evt);


  }


  setFiltroOnInit() {

    let filtriOBJStr = sessionStorage.getItem('Filtri');

    const filtriOBJ: Object = JSON.parse(filtriOBJStr)

    if (filtriOBJ && filtriOBJ['soggettiFiltri']) {

      if (filtriOBJ['soggettiFiltri'].queryString.length > 0) {


        //filtriOBJ[this.filterTemplateKey].queryString = !filtriOBJ[this.filterTemplateKey].queryString.includes('=') ? '' :  filtriOBJ[this.filterTemplateKey].queryString;

        //this.filterGrid += filtriOBJ[this.filterTemplateKey].queryString;

        if (this.filterGrid.toLowerCase().endsWith('asc') || this.filterGrid.toLowerCase().endsWith('desc'))
          this.filterGrid += '&' + filtriOBJ['soggettiFiltri'].queryString.replace(/[?]/g, '');  //this.filterGrid.split('?')[0];
        else
          this.filterGrid += '&' + filtriOBJ['soggettiFiltri'].queryString;  //this.filterGrid.split('?')[0];


        setTimeout(
          () => {

            for (let i = 0; i < document.getElementsByClassName('dx-icon export icon-filter').length; i++) {

              if ((document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).parentElement.parentElement.id == 'bottoneFiltroToolbar') {

                if (filtriOBJ['soggettiFiltri'].queryString.length > 0)
                  (document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).style.color = '#edcd5f';

                break;
              }

            }

            if (this.nicaAnagrafica)
              this.nicaAnagrafica.refresh();

          }, 500
        );


      }

    }
  }



  setTabsSoggetto(param) {

    this.selectedIndex[param.service];
    this.SubjectCall = param.service
    if (this.filterID['templateTab']) {
      if (typeof this.filterID['templateTab'][param.service] != 'undefined') {
        this.templateTab = this.filterID['templateTab']
        /* if (this.SubjectCall == 'soggetto')

          this.template = this.templateTab[param.service]; */

      }
    }


    if (param.service == 'ConfigurazioniModuloViviFir' || param.service == 'ConfigurazioniModuloRentri') {
      if (typeof this.templateTab[param.service] != 'undefined') {
        this.template = this.templateTab[param.service]
      } else {
        this.template = param.templateView;
      }

      let nomeModulo = ''
      if (param.service == 'ConfigurazioniModuloViviFir') {
        nomeModulo = 'VIVIFIR'

      }
      // if (param.service == 'ConfigurazioniModuloRentri') {
      //   nomeModulo = 'RENTRI'
      // }
      if (param.service == 'Configurazioni') {
        nomeModulo = 'Configurazioni'
      }




      this.dataToSend = [
        {
          idTabRif: this.filterID['idSoggetto'],
          nomeTabRif: param.service,

          dati:
          {
            codiceFiscale: this.filterID['CODFIS'],
            nomeModulo: nomeModulo
          }


        }
      ]
      this.SetToolbarButtons(this.serviceButtonsArray, [], '', '', true);

      //Setta dati per il componente vivifir

      if (param.service == 'ConfigurazioniModuloViviFir') {
        console.log('ConfigurazioniModuloViviFir', this.filterID)


        /* this.datiVivirir = {

            codiceFiscale:
          
        } */
      }
    }


    this.soggettoTabs = [
      {
        name: 'Anagrafica azienda',
        icon: 'glyphicon icon-soggetto-form',
        hint: 'Informazioni dell\'azienda',
        displayMode: 'in-line',
        path: 'main/anagrafiche-propri-impianti',
        componentName: 'AnaSoggettoComponent',
        service: 'soggetto',
        api: 'soggetto',
        templateComponent: this.templateTab[this.SubjectCall],
        visible: true,
        disabled: false
      },
      {
        name: 'Configurazioni',
        icon: 'glyphicon icon-soggetto-form',
        hint: 'configurazione del\'modulo DH-WASTE',
        displayMode: 'in-line',
        path: 'main/anagrafiche-propri-impianti',
        componentName: 'ConfigurazioniModuliComponent',
        service: 'Configurazioni',
        api: 'ConfigurazioniModuli',
        templateComponent: 'component',
        visible: this.filterID['nsAzienda'] && this.idTipoUtente >= 3,
        disabled: this.filterID['idSoggetto'] > 0 ? false : true
      },
      // {
      //   name: 'Configurazione R.E.N.T.R.i',
      //   icon: 'glyphicon icon-soggetto-form',
      //   hint: 'configurazione del\'modulo vivifir',
      //   displayMode: 'in-line',
      //   path: 'main/anagrafiche-propri-impianti',
      //   componentName: 'ConfigurazioniModuliComponent',
      //   service: 'ConfigurazioniModuloRentri',
      //   api: 'ConfigurazioniModuliRentri',
      //   templateComponent: 'component',
      //   visible: this.filterID['nsAzienda'] && this.idTipoUtente >= 3,
      //   disabled: this.filterID['idSoggetto'] > 0 ? false : true
      // },

      {
        name: 'Vidimazione',
        // name: 'Config.Modulo ViViFir Spurghisti',
        icon: 'glyphicon icon-soggetto-form',
        hint: 'configuraziobe del\'modulo vivifir per spurgisti e soggetti non isritti al R.E.N.T.R.i',
        displayMode: 'in-line',
        path: 'main/anagrafiche-propri-impianti',
        componentName: 'ConfigurazioniModuliComponent',
        service: 'ConfigurazioniModuloViviFir',
        api: 'ConfigurazioniModuli',
        templateComponent: 'component',
        visible: this.filterID['nsAzienda'] && this.idTipoUtente >= 3,
        disabled: this.filterID['idSoggetto'] > 0 ? false : true
      },



    ]

  }

  tabClick(ev) {


    const itemData = ev.itemData;


    if (itemData.service == this.SubjectCall) {
      return
    }

    let data = [];

    if (this.template == 'form') {
      delete this.filterID['nomeModulo'];
      const validation = this.formAnagrafica.validate();
      if (validation.isValid) {
        this.formAnagrafica.showNotifyAfterSave = false;
        this.formAnagrafica.onFormSubmit();
      } else {
        return
      }

    }

    if (this.SubjectCall == 'soggetto') {
      this.templateTab[this.SubjectCall] = this.template;

    }

    let nomeModulo = ''
    if (itemData.service == 'ConfigurazioniModuloViviFir') {
      nomeModulo = 'VIVIFIR'
    }
    // if (itemData.service == 'ConfigurazioniModuloRentri') {
    //   nomeModulo = 'RENTRI'
    // }
    if (itemData.service == 'Configurazioni') {
      nomeModulo = 'Configurazioni'
    }

    this.filterID['nomeModulo'] = nomeModulo

    let dataToTake


    setTimeout(() => {
      switch (this.SubjectCall) {
        case 'soggetto':

          data = this.formAnagrafica.dataSet;
          data['nomeModulo'] = nomeModulo;

          dataToTake = [
            {
              keyResult: 'idSoggetto',
              valueToTake: 'id'
            },
            {
              keyResult: 'nomeModulo',
              valueToTake: 'nomeModulo'
            },

          ]


          this.buildDataToTake(data, dataToTake)

          break;

        case 'ConfigurazioniModuloViviFir':

          data['idSoggetto'] = this.filterID['idSoggetto'];
          data['nomeModulo'] = nomeModulo


          dataToTake = [
            {
              keyResult: 'id',
              valueToTake: 'idSoggetto'
            },
            {
              keyResult: 'nomeModulo',
              valueToTake: 'nomeModulo'
            },
            {
              keyResult: 'NostreAziende',
              valueToTake: 'S'
            },
          ]
          data['id'] = this.filterID['idSoggetto']
          this.buildDataToTake(data, dataToTake)
          break;

        // case 'ConfigurazioniModuloRentri':

        //   data['idSoggetto'] = this.filterID['idSoggetto'];
        //   data['nomeModulo'] = nomeModulo

        //   dataToTake = [
        //     {
        //       keyResult: 'id',
        //       valueToTake: 'idSoggetto'
        //     },
        //     {
        //       keyResult: 'nomeModulo',
        //       valueToTake: 'nomeModulo'
        //     },
        //     {
        //       keyResult: 'NostreAziende',
        //       valueToTake: 'S'
        //     },
        //   ]
        //   data['id'] = this.filterID['idSoggetto']
        //   this.buildDataToTake(data, dataToTake)
        //   break;
        case 'Configurazioni':

          data['idSoggetto'] = this.filterID['idSoggetto'];
          data['nomeModulo'] = nomeModulo

          dataToTake = [
            {
              keyResult: 'id',
              valueToTake: 'idSoggetto'
            },
            {
              keyResult: 'nomeModulo',
              valueToTake: 'nomeModulo'
            },
            {
              keyResult: 'NostreAziende',
              valueToTake: 'S'
            },
          ]
          data['id'] = this.filterID['idSoggetto']
          this.buildDataToTake(data, dataToTake)
          break;

      }


      this.filterID['templateTab'] = this.templateTab;
      this.refreshPage(data, '', itemData.service, this.templateTab[itemData.service], itemData);

    }, 300);




  }

  onOptionChanged(ev) {

  }

  rowGridSel(ev) {

    if (this.SubjectCall == 'soggetto' && this.template == 'grid') {
      //this.filterID['idSoggetto'] = ev.id;
      //const data = this.filterID;
      //this.refreshPage(data, 'Elenco', this.SubjectCall, 'grid');
    }

  }

  formItemsEventSoggetto(e) {

    console.log('formItemsEventSoggetto-->', e)
    if (e.name == "onValueChanged") {


      // if (e.campo.dataField == 'comune') {
      //   if (e.formData.isoFiscale == 'IT')
      //     this.formAnagrafica.formRefreshInputData('stato', 'IT');
      // }

      if (e.campo.dataField == 'stato') {
        if (e.formData.stato !== 'IT') {
          this.formAnagrafica.formRefreshInputData('siglaProvincia', null);
          this.formAnagrafica.formRefreshInputData('istatComune', null);
          this.formAnagrafica.itemOption('indirizzoSedeLegale.siglaProvincia', 'disabled', true);
          this.formAnagrafica.itemOption('indirizzoSedeLegale.istatComune', 'disabled', true);
        } else {
          this.formAnagrafica.itemOption('indirizzoSedeLegale.siglaProvincia', 'disabled', false);
          this.formAnagrafica.itemOption('indirizzoSedeLegale.istatComune', 'disabled', false);
        }
        this.changeDetector.detectChanges()
      }

      // if (e.campo.dataField == 'isoFiscale') {
      //   if (e.value != 'IT') {
      //     e.masterComponent.itemOption('indirizzoSedeLegale.comune', 'validationRules', null)
      //     e.masterComponent.itemOption('indirizzoSedeLegale.comune', 'readonly', false)
      //     e.masterComponent.itemOption('indirizzoSedeLegale.siglaProvincia', 'validationRules', null);
      //     e.masterComponent.itemOption('indirizzoSedeLegale.readonly', 'validationRules', null);

      //     this.formAnagrafica.formRefreshInputData('siglaProvincia', null);
      //     // this.formAnagrafica.formRefreshInputData('cap', null);
      //     this.formAnagrafica.formRefreshInputData('istatComune', null);

      //     if (typeof e.formData.istatComuneProv != 'undefined') {
      //       if (e.formData.istatComuneProv != '101') {
      //         this.formAnagrafica.formRefreshInputData('istatComune', e.formData.istatComuneProv);

      //       }
      //     }

      //   } else if (e.value == 'IT') {


      //     let validationRules = [{
      //       type: 'required',
      //       message: 'Campo Obbligatorio'
      //     }]

      //     e.masterComponent.itemOption('indirizzoSedeLegale.comune', 'validationRules', validationRules)
      //     e.masterComponent.itemOption('indirizzoSedeLegale.siglaProvincia', 'validationRules', validationRules)
      //     e.masterComponent.itemOption('indirizzoSedeLegale.comune', 'readonly', true)
      //     this.formAnagrafica.formRefreshInputData('comune', null);

      //     if (typeof e.formData.istatComuneProv != 'undefined') {
      //       if (e.formData.istatComuneProv == '101') {
      //         if (e.formData.comune) {
      //           const filter = `?$filter=( descrizione eq '${e.formData.comune}' )`;
      //           this.anagraficaService.getElenco('comune', '', filter).then(res => {
      //             let items = res['items'][0]

      //             this.formAnagrafica.formRefreshInputData('istatComune', items.id);
      //           })
      //         }


      //       }
      //     }


      //   }


      // }

    }

    if (e.name == "selectedItemLista") {
      // if (e.campo.dataField == 'siglaProvincia') {
      //   this.formAnagrafica.formRefreshInputData('stato', 'IT');
      // }

      if (e.campo.dataField == 'stato') {
        if (e.formData.stato !== 'IT') {
          this.formAnagrafica.formRefreshInputData('siglaProvincia', null);
          this.formAnagrafica.formRefreshInputData('istatComune', null);
          // this.formAnagrafica.formRefreshInputData('comune', null);
          // this.formAnagrafica.formRefreshInputData('cap', null);
          this.formAnagrafica.itemOption('indirizzoSedeLegale.siglaProvincia', 'disabled', true);
          this.formAnagrafica.itemOption('indirizzoSedeLegale.istatComune', 'disabled', true);
        } else {
          this.formAnagrafica.itemOption('indirizzoSedeLegale.siglaProvincia', 'disabled', false);
          this.formAnagrafica.itemOption('indirizzoSedeLegale.istatComune', 'disabled', false);
        }
        this.changeDetector.detectChanges()
      }
    }


  }

  formEventSoggetto(e) {

    if (e.name == 'return') {
      const copyF = this.filterID;

      //Se nei filtri ho movimento true allora chiudi la pagina e torna ai movimenti
      if (copyF['movimento']) {
        e.event = 5
        this.buttonEmitted(e);
        return
      }

      let dataSet = this.formAnagrafica.dataSet

      for (let x in dataSet) {
        if (x != 'idSoggetto') {
          delete this.filterID[x];
        }

      }



      this.formEvent(e);
      return
    }
    if (e.name == 'submittedEditOk' || e.name == 'submittedInsertOk' || e.name == 'return') {
      this.formEvent(e)
    }

    if (e.name == 'formDataInit') {
      this.SetToolbarButtons(this.serviceButtonsArray, e.formData);
    }

    if (e.name == 'infoCF' || e.name == 'infoPiva') {
      let current
      if (e.name == 'infoCF') {
        current = e.data.codiceFiscale
      }
      if (e.name == 'infoPiva') {
        current = e.data.partitaIVA
      }
      if (!current) {
        alert("Inserire un codice fiscale o P.Iva", 'Attenzione!');
        return
      }
      if (current) {
        current = current.trim();
      }

      let dataTosend = [{
        dati: current
      }]


      let id = this.openComponentInPopUP('NicaInfoAnagraficaAziendaComponent', dataTosend, undefined, '800', 'Dati Impresa', false, true);


      this.userComponentService.outputComponent.subscribe(currentOutput => {

        if (currentOutput.eventName == 'incollaDatiImpresa' && currentOutput.componentName == 'NicaInfoAnagraficaAziendaComponent' && NicaInfoAnagraficaAziendaComponent.isMsgPartitaIVA(currentOutput)) {

          // let desc = "?$filter=( descrizione eq '" + currentOutput['localita'] + "' )";
          const localita = currentOutput['localita'].replace(/'/g, "''");
          let desc = `?$filter=descrizione eq '${localita}'`;

          this.anagraficaService.getElenco('Comune', '', desc).then(ree => {
            if (ree['items'] && ree['items'].length > 0) {
              const item = ree['items'][0];
              this.formAnagrafica.formRefreshInputData('istatComune', item['id']);
              this.formAnagrafica.formRefreshInputData('comune', item['descrizione']);
              this.formAnagrafica.formRefreshInputData('stato', 'IT');
              this.formAnagrafica.formRefreshInputData('cap', item['cap']);
            }
          });


          if (currentOutput['ragione_Sociale'].length > 45) {
            this.formAnagrafica.formRefreshInputData('ragioneSociale', currentOutput['ragione_Sociale'].slice(0, 45));
            this.formAnagrafica.formRefreshInputData('estensione', currentOutput['ragione_Sociale'].slice(45, 90));
          } else {
            this.formAnagrafica.formRefreshInputData('ragioneSociale', currentOutput['ragione_Sociale']);
            this.formAnagrafica.formRefreshInputData('estensione', '');
          }

          this.formAnagrafica.formRefreshInputData('isoFiscale', 'IT');
          this.formAnagrafica.formRefreshInputData('siglaProvincia', currentOutput['prov']);
          this.formAnagrafica.formRefreshInputData('indirizzo', currentOutput['indirizzo']);
          this.formAnagrafica.formRefreshInputData('comune', currentOutput['localita']);
          this.formAnagrafica.formRefreshInputData('partitaIVA', currentOutput['tax']);
          this.formAnagrafica.formRefreshInputData('codiceFiscale', currentOutput['vat']);
          this.formAnagrafica.formRefreshInputData('civico', currentOutput['civico']);
          this.formAnagrafica.formRefreshInputData('stato', 'IT');


          if (!currentOutput['escludiPec']) {
            this.formAnagrafica.formRefreshInputData('pec', currentOutput['pec']);
          }

          this.userComponentService.destroyCurrentOpenPopUp('NicaInfoAnagraficaAziendaComponent');
          this.userComponentService.destroyOutputComponent();



        }
        if (currentOutput.eventName == 'annullaDatiImpresa' && currentOutput.componentName == 'NicaInfoAnagraficaAziendaComponent') {

          this.userComponentService.destroyCurrentOpenPopUp('NicaInfoAnagraficaAziendaComponent');
          this.userComponentService.destroyOutputComponent();


        }


      });




    }


    return
    if (e.name == 'infoCF' || e.name == 'infoPiva') {
      let current = ''
      if (e.name == 'infoCF') {
        current = e.data.codiceFiscale.trim();
      }
      if (e.name == 'infoPiva') {
        current = e.data.partitaIVA.trim();
      }

      if (!current) {
        alert("Inserire un codice fiscale o P.Iva", 'Attenzione!');
        return
      }
      let dataTosend = [{
        dati: current
      }]



      let id = this.openComponentInPopUP('NicaInfoAnagraficaAziendaComponent', dataTosend, undefined, '800', 'Dati Impresa', false, true);

      console.log('NicaInfoAnagraficaAziendaComponent-->', id)

      this.userComponentService.outputComponent.subscribe(currentOutput => {

        if (currentOutput.eventName == 'incollaDatiImpresa' && currentOutput.componentName == 'NicaInfoAnagraficaAziendaComponent' && NicaInfoAnagraficaAziendaComponent.isMsgPartitaIVA(currentOutput)) {

          //console.warn('CORRENTE',currentOutput)

          //if (ress['soloDati']) {

          //let desc = "?$filter=((contains(tolower(descrizione)," + "'" + ress['localita'].toLowerCase() + "')))"

          let desc = "?$filter=( descrizione eq '" + currentOutput['localita'] + "' )";
          this.anagraficaService.getElenco('Comune', '', desc).then(ree => {

            if (ree['items']) {
              this.formAnagrafica.formRefreshInputData('istatComune', ree['items'][0]['id']);
              this.formAnagrafica.formRefreshInputData('comune', ree['items'][0]['descrizione']);
              this.formAnagrafica.formRefreshInputData('stato', 'IT');
              this.formAnagrafica.formRefreshInputData('cap', ree['items'][0]['cap']);
              this.formAnagrafica.formRefreshInputData('stato', 'IT');
            }

          })




          this.formAnagrafica.formRefreshInputData('ragioneSociale', currentOutput['ragione_Sociale']);
          this.formAnagrafica.formRefreshInputData('isoFiscale', 'IT');
          this.formAnagrafica.formRefreshInputData('siglaProvincia', currentOutput['prov']);
          this.formAnagrafica.formRefreshInputData('indirizzo', currentOutput['indirizzo']);
          this.formAnagrafica.formRefreshInputData('comune', currentOutput['localita']);
          this.formAnagrafica.formRefreshInputData('partitaIVA', currentOutput['tax']);
          this.formAnagrafica.formRefreshInputData('codiceFiscale', currentOutput['vat']);
          this.formAnagrafica.formRefreshInputData('civico', currentOutput['civico']);
          this.formAnagrafica.formRefreshInputData('stato', 'IT');


          if (!currentOutput['escludiPec']) {
            this.formAnagrafica.formRefreshInputData('pec', currentOutput['pec']);
          }

          this.userComponentService.destroyCurrentOpenPopUp('NicaInfoAnagraficaAziendaComponent');
          this.userComponentService.destroyOutputComponent();



        }
        if (currentOutput.eventName == 'annullaDatiImpresa' && currentOutput.componentName == 'NicaInfoAnagraficaAziendaComponent') {

          this.userComponentService.destroyCurrentOpenPopUp('NicaInfoAnagraficaAziendaComponent');
          this.userComponentService.destroyOutputComponent();


        }


      });



    }
  }



  async onChiusuraAnnullaFiltro(evt) {

    if (this.nicaFiltroSoggetti)
      await this.nicaFiltroSoggetti.annullaFiltro();


    this.pannelloFiltriAvanzatiVisibile = false;


  }

  onShowing(e) {
    //////console.log('eventooooo',e);

    //this.showEdit = true;
    e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    e.component.content().classList.add("soggetto-form"); //add class to content

    //<div class="dx-item-content dx-box-item-content" style="width: auto; height: auto; display: flex; flex-basis: 0px; flex-grow: 1; flex-direction: column;"></div>
    //soggetto-form
    setTimeout(() => {
      var tt = $(".soggetto-form").find(".dx-item .dx-box-item");
      //var tt=$(".dx-item-content .dx-box-item-content");
      //tt[tt.length-1].remove();
      //console.log("ecco le classi ",tt);

    }, 200);

    //$( ".hello" ).remove();
    /*
    if(this.formEditingPopup !== undefined)
      this.formEditingPopup.visible=true;
    */
  }



  appToolBarEvent(evt) {

    console.warn(evt);

  }

  optionalButtonClickToolBar(event) {
    console.log('optionalButtonClickToolBar', event);


    if (event == "resettaFiltro") {

      this.resettaFiltroApplicato()


    }

    if (event == "pannelloFiltriAvanzatiVisibile") {
      //console.warn(event);

      let instanceData = {
        filtroKeySessionStorage: this.filterTemplateKey,
        nomeTemplate: this.filterTemplateKey,
        captionHidden: true,
        nColForm: '2',
        helpDoc: `${this.filterTemplateKey}.html`

      }

      let guid = this.openComponentInPopUP('NicaFiltroComponent', [], instanceData, '1550', 'Filtri Avanzati', false, true, 'center', `${this.filterTemplateKey}.html`);

      this.userComponentService.outputComponent.subscribe(async currentOutput => {
        console.log('Ricevuto evento:', currentOutput);
        // serve per il pulsante annulla
        if (currentOutput.name == 'return' && currentOutput.guid == guid) {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          return
        }
        if (currentOutput.name == 'resettaFiltro' && currentOutput.guid == guid) {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          this.resettaFiltroApplicato(this.filterTemplateKey)
          return
        }

        if (currentOutput.name == 'queryOk' && currentOutput.guid == guid) {
          if (currentOutput.formDataAA) {
            const formData = JSON.parse(JSON.stringify(currentOutput.formDataAA));
            const isOR = formData.UL_tipoRicerca == 'or' ? true : false;


            const ul: Record<string, any> = {};
            const soggetto: Record<string, any> = {};
            ul['UL_tipoAttivita'] = []
            Object.keys(formData).forEach(key => {

              if (key.includes('UL_')) {
                switch (key) {
                  case 'descrizione_UL_idTipo':
                  case 'descrizione_UL_idZona':
                  case 'descrizione_UL_idCategoria':
                    delete formData[key]
                    break;

                  case 'UL_isProduttore':
                  case 'UL_isTrasportatore':
                  case 'UL_isIntermediario':
                  case 'UL_isSmaltitore':
                  case 'UL_isDestinatario':
                    if (formData[key])
                      ul['UL_tipoAttivita'] = { ...ul['UL_tipoAttivita'], [key]: formData[key] }


                    //formData['tipoAttivita'] =tipoAttivita 
                    //ul['tipoAttivita'] = tipoAttivita
                    break;
                  default:
                    ul[key] = formData[key];
                }




              } else {
                if (key.includes('SD_')) {
                  switch (key) {
                    case 'descrizione_SD_idCategoria':
                    case 'descrizione_SD_idZona':
                      delete formData[key]
                      soggetto[key] = formData[key];
                      break;
                    default:
                      soggetto[key] = formData[key];
                  }
                }

              }
            });


            let queryString = this.buildFilterList(soggetto);

            if (Object.keys(ul).length > 0) {
              const mergedObj = { ...soggetto, ...ul };
              let querymergedObj = this.buildFilterList(mergedObj)
              let queryStringUL22 = ``;
              if (querymergedObj) {
                queryStringUL22 = `?$filter=${querymergedObj}`;
              }

              const newObjUL: Record<string, any> = {};
              Object.keys(ul).forEach(key => {
                if (key == 'UL_tipoAttivita') {
                  const newObj = {};
                  for (let x in ul[key]) {
                    if (ul[key].hasOwnProperty(x)) {
                      const newKey = x.replace(/^UL_/, ''); // Remove the prefix
                      newObj[newKey] = ul[key][x];

                    }
                  }
                  ul[key] = newObj
                }
                newObjUL[key.replace('UL_', '')] = ul[key];
              });
              let queryStringUL = this.buildFilterList(newObjUL);
              let filterOdataUL = `?$filter=${queryStringUL}`
              this.filterUL = filterOdataUL;

              //currentOutput.queryString = currentOutput.queryString.replace('descrizione_IdTipo')

              this.onFilterQueryStringEmitted(queryStringUL22);
              this.userComponentService.destroyCurrentOpenPopUpByGuid(guid);
              return
            }

            if (this.filterGrid.length > 0) {
              let filterOdata = `$filter=${queryString}`
              this.updateFilterGrid(filterOdata);

              this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
            }

          }


        } else {
          console.log('Nessun valore di filtro ricevuto.');
        }
      });


      //this.pannelloFiltriAvanzatiVisibile = true;

      return
      setTimeout(
        () => {

          if (!this.nicaFiltroSoggetti)
            return;

          if (!this.nicaFiltroSoggetti.filtroForm.formEdit.formData['sD_Stato']) {

            let editor = this.nicaFiltroSoggetti.filtroForm.formEdit.instance.getEditor('sD_Stato');

            editor.option('value', "IT");

          }




        }, 500
      )

    }


  }



  async onFilterQueryStringEmitted(queryString: string) {
    if (!this.nicaAnagrafica.griglia.instance) {
      console.error("Errore: griglia non disponibile.");
      return;
    }

    if (!queryString || queryString.trim().length === 0) {
      console.error("Errore: queryString non definita o vuota.");
      return;
    }

    console.log("QueryString prima del caricamento dei dati:", queryString);
    let filterData = await this.loadFilterData(queryString);
    if (!filterData) {
      console.error("Errore: Nessun dato di filtro ricevuto.");
      return;
    }

    console.log("Dati filtro ricevuti:", filterData);
    const updatedQueryString = this.buildFilterQuery(filterData);
    console.log("QueryString aggiornata:", updatedQueryString);
    this.applyFilterSettings(updatedQueryString);
  }

  private async loadFilterData(queryString: string): Promise<any> {
    //console.log('Caricamento dati con queryString:', queryString);
    if (!queryString || queryString.length === 0 || queryString === "") {
      return
    }
    const response = await this.http.get<any>(`${environment.BASE_API_URL}SoggettoSede/GetAllSoggettiSedi${queryString}`).toPromise();
    //console.log('Dati ricevuti:', response);
    return response;
  }

  buildFilterQuery(filters): string {

    if (!filters || !filters.items || filters.items.length === 0) {
      console.log('Nessun filtro valido ricevuto');
      return "$filter=Id eq null";
    }

    let query = "$filter=";
    filters.items.forEach(item => {
      Object.keys(item).forEach(key => {
        const value = item[key];
        const modifiedKey = key.startsWith('sD_') ? key.substring(3) : key;

        // Aggiungi solo se la chiave modificata è 'Id'
        if (modifiedKey === 'Id' && typeof value === 'number') {
          query += ` (${modifiedKey} eq ${value}) or`;
        }
      });
    });

    // Rimuovi l'ultimo "or" dalla stringa di query se la query è maggiore di "$filter="
    if (query.length > "$filter=".length) {
      return query.slice(0, -3);
    } else {
      // Se nessun Id è stato aggiunto, restituisci una stringa vuota o un'altra logica appropriata
      console.log('Nessun Id valido per la query');
      return "";
    }
  }

  private applyFilterSettings(queryString: string): void {
    console.log("Applicazione delle impostazioni di filtro");
    if (!queryString || queryString.length === 0) {
      console.error("Errore: queryString non definita o vuota.");
      return;
    }

    this.updateFilterGrid(queryString);
    this.updateFilterIconColors(queryString.length > 0);

    if (!this.nicaAnagrafica || !this.nicaAnagrafica.griglia || !this.nicaAnagrafica.griglia.instance) {
      console.error('Impossibile aggiornare la griglia: componente griglia non disponibile');
      return;
    }

    this.nicaAnagrafica.griglia.instance.refresh();
    this.userComponentService.destroyCurrentOpenPopUp('NicaFiltroComponent');
    this.pannelloFiltriAvanzatiVisibile = false;  // Aggiorna lo stato del pannello dei filtri
  }


  setDisabledToolbar() {
    return this.id == '0' || !this.id ? true : false
  }



}
